import Alert from 'common/components/alert/Alert';
import Page from 'common/components/page/Page';
import { PageTemplates } from 'common/components/page/PageTemplates';
import { isActionCompleteFail } from 'common/services/api/isActionCompleteFail';
import AlertType from 'common/types/AlertType';
import { ActionCompleteResponse } from 'common/types/ApiResponse';
import { Spinner, Card, Button } from 'react-bootstrap';
import SecurityQuestionInput from '../components/SecurityQuestionInput';
import { ResetQuestionsState } from './ResetQuestionsReducer';

interface IResetQuestionsPresenter {
  allowedToResetResponse: ActionCompleteResponse | null;

  resetQuestionsResponse: ActionCompleteResponse | null;
  resetData: ResetQuestionsState;
  allowedToReset: boolean;
  allowedLoading: boolean;
  onQuestionChange: (num: '1' | '2' | '3') => (value: string) => void;
  onAnswerChange: (num: '1' | '2' | '3') => (value: string) => void;
  onSubmit: () => void;
  resetLoading: boolean;
  feedback: string[];
}

const ResetQuestionsPresenter = (props: IResetQuestionsPresenter) => {
  return (
    <Page template={PageTemplates.centered}>
      <Card>
        <Card.Body>
          {props.allowedLoading && <Spinner animation={'border'} />}
          {!props.allowedLoading &&
            isActionCompleteFail(props.allowedToResetResponse) && (
              <Alert type={AlertType.danger}>
                <ul>
                  {props.allowedToResetResponse.payload.errorInfo?.errorItems?.map(
                    (error, i = 0) => (
                      <li key={i++}>{error}</li>
                    )
                  )}
                </ul>
              </Alert>
            )}
          {!props.allowedLoading && props.allowedToReset && (
            <>
              {!props.resetLoading &&
                isActionCompleteFail(props.resetQuestionsResponse) && (
                  <Alert type={AlertType.danger}>
                    <ul>
                      {props.resetQuestionsResponse.payload.errorInfo?.errorItems?.map(
                        (error, i = 0) => (
                          <li key={i++}>{error}</li>
                        )
                      )}
                    </ul>
                  </Alert>
                )}
              <SecurityQuestionInput
                index={1}
                onQuestionChange={props.onQuestionChange('1')}
                onAnswerChange={props.onAnswerChange('1')}
                blacklist={[
                  props.resetData.security[2].question,
                  props.resetData.security[3].question,
                ]}
                question={props.resetData.security[1].question}
                answer={props.resetData.security[1].answer}
                errors={props.feedback}
              />
              <SecurityQuestionInput
                index={2}
                onQuestionChange={props.onQuestionChange('2')}
                onAnswerChange={props.onAnswerChange('2')}
                blacklist={[
                  props.resetData.security[1].question,
                  props.resetData.security[3].question,
                ]}
                question={props.resetData.security[2].question}
                answer={props.resetData.security[2].answer}
                errors={props.feedback}
              />
              <SecurityQuestionInput
                index={3}
                onQuestionChange={props.onQuestionChange('3')}
                onAnswerChange={props.onAnswerChange('3')}
                blacklist={[
                  props.resetData.security[1].question,
                  props.resetData.security[2].question,
                ]}
                question={props.resetData.security[3].question}
                answer={props.resetData.security[3].answer}
                errors={props.feedback}
              />
              <Button
                color='primary'
                onClick={props.onSubmit}
                className='mt-2'
                disabled={props.resetLoading}
              >
                Reset Security Questions
              </Button>
            </>
          )}
        </Card.Body>
      </Card>
    </Page>
  );
};

export default ResetQuestionsPresenter;
